import { push } from 'connected-react-router'
import { call, put, takeLatest, delay } from "redux-saga/effects";
import ActionTypeConstants from "helpers/ActionTypeConstants";
import { actionApiCall } from "helpers/api/ApiCalls";

function* emailAffiliateFilesSaga({ payload }) {
    try {
        const apiResponse = yield call(actionApiCall, {
            actionType: ActionTypeConstants.EMAIL_AFFILIATE_FILES,
            data: {
                id: parseInt(payload, 10)
            }
        });
        if (apiResponse.res.data.response === 200) {
            yield put({ type: ActionTypeConstants.LOAD_AFFILIATES });
            yield put(push('/achieve/affiliates'));
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.message || "Email sent",
                    color: "success"
                }
            });
            yield delay(10000)
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
        } else {
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.message || "We ran into an issue while sending the email",
                    color: "danger"
                }
            });
            yield delay(10000);
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
        }
    } catch (err) {
        yield put({
            type: ActionTypeConstants.SHOW_ALERT,
            payload: {
                message: "Server error. Please try again later",
                color: "danger"
            }
        });
        yield delay(10000);
        yield put({ type: ActionTypeConstants.HIDE_ALERT });
    }
}

export default function*() {
    yield takeLatest(ActionTypeConstants.EMAIL_AFFILIATE_FILES, emailAffiliateFilesSaga);
}
